<template lang="pug">
  CrmFunnelMemberListApi(
    v-if="funnelId"
    :funnelId="funnelId"
    :companyId="companyId"
    :canManage="canManage"
    )
</template>

<script>
import CrmFunnelMemberListApi from '@/components/crm/CrmFunnelMemberListApi.vue';

export default {
  name: 'CrmFunnelMemberListPopupWrappable',
  components: { CrmFunnelMemberListApi },
  data() {
    return {
      funnelId: null,
      companyId: null,
      // состав воронки участнику доступен только на просмотр
      canManage: false,
    };
  },
  methods: {
    init(params) {
      this.funnelId = params.funnelId;
      this.companyId = params.companyId;
      this.canManage = params.canManage ?? false;
    },
  },
};
</script>
